module.exports = __webpack_public_path__ + "59bb10ff3c79911f610438bab3cdbd9c.pdf";